import { View, Text, StyleSheet, TouchableOpacity, TextInput, ActivityIndicator, FlatList, Modal, PixelRatio } from 'react-native'
import React, { useEffect, useState } from 'react'
import { useNavigation } from '@react-navigation/native';
import Colours from '../../utils/Colours';
import SearchIcon from '../../icons/SearchIcon';
import useAuth from '../../hooks/useAuth';
import PublicProfile from '../publicProfile/PublicProfile';
import AppTextInput from '../../utils/ColourThemes/AppTextInput';
import { Image } from 'expo-image';

const dpr = Math.round(PixelRatio.get() || 1);
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = 'dxfdmlk0f';
const MAX_RETRIEZ = 20;

const BodyFriendListSearch = ({ title, number, friendsList, isLoading12 }) => {
    const [isFormContainerClicked, setIsFormContainerClicked] = useState(false)

    const [showPublicProfile, setShowPublicProfile] = useState(false)
    const [uniqueFriendsList, setUniqueFriendsList] = useState([])
    const [userData, setUserData] = useState(null)
    const [errorMessage, setErrorMessage] = useState('');

    // const [foundUser, setFoundUser] = useState()

    const { username } = useAuth()

    const navigation = useNavigation()

    useEffect(() => {
        const uniqueFriendsList = Array.from(
            new Map(friendsList.map((friend) => [friend._id, friend])).values()
        );
        setUniqueFriendsList(uniqueFriendsList)

    }, [friendsList])


    const handleOnSearchContent = (username) => {
        //console.log(username)
        //  checkUsernameExists(username)
    }
    const handleFriendsData = (friendData) => {
        //console.log('friendData', friendData)
        setUserData(friendData)
        setShowPublicProfile(true)
    }


    const getOptimizedCloudinaryUrl = (
        originalUrl,
        targetWidth,
        targetHeight
    ) => {
        if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
            return originalUrl;
        }

        // 1. Define the transformations
        const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_${dpr}`;

        //const transformations = `w_${targetWidth},f_auto,q_90,dpr_auto`;

        const regex = /upload\/v\d+\//;

        return originalUrl.replace(
            regex,
            `upload/${transformations}/`
        );
    };


    const handleImageError = () => {
        if (retryCount < MAX_RETRIEZ) {
            // Increment the retry counter
            setRetryCount(prevCount => prevCount + 1);

            // Force component re-render by changing the key
            setImageKey(prevKey => prevKey + 1);

            //console.log(`Image failed to load. Retrying... Attempt ${retryCount + 1}`);
        } else {
            // Log final failure or set a state to show a permanent fallback icon
            //console.log('Image failed to load after maximum retries.');
        }
    };





    return (
        <View style={styles.higherTablebodyContainer}>
            <View style={styles.JoinedNumber}>
                {
                    //console.log('friendsalist', uniqueFriendsList)
                }
                <Text style={{ marginTop: 10, marginBottom: 10, fontSize: 15, color: Colours.DARKLIGHTGRAY, fontFamily: 'Sen-Bold' }} >{title} </Text>
                {/* <Text style={{ paddingLeft: 1, paddingBottom: 0, color: Colours.PRIMARY, fontFamily: 'Sen-Regular' }}>|: {uniqueFriendsList.length - 1}</Text> */}
                <Text style={{ paddingLeft: 1, paddingBottom: 0, color: Colours.PRIMARY, fontFamily: 'Sen-Regular' }}>|: </Text>

            </View>
            <View style={styles.searchBoxContainer}>
                <View style={styles.SearchBox}>
                    <AppTextInput
                        style={[styles.inputTxt, isFormContainerClicked && styles.focusedBorder,
                            //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                        ]}
                        placeholder="Search User"
                        onFocus={() => setIsFormContainerClicked(true)}
                        onBlur={() => setIsFormContainerClicked(false)}
                        // value={tableCaption}
                        onChangeText={handleOnSearchContent}
                    />
                </View>
                <View style={{ backgroundColor: Colours.DARKLIGHTGRAY, height: 30, width: 1, }}></View>
                <SearchIcon color={Colours.DARKGRAY} />
            </View>

            {isLoading12 ? (
                <View style={{ display: 'flex', height: 20, justifyContent: 'center', alignItems: 'center' }}>
                    <ActivityIndicator color={Colours.PRIMARY} size={'small'} />
                </View>
            ) : (

                <FlatList
                    data={uniqueFriendsList.filter((item) => item.username !== username)}
                    keyExtractor={(item) => item._id}
                    scrollEnabled={false}
                    renderItem={({ item: friendData }) => {

                        const newUserFullImage = getOptimizedCloudinaryUrl(
                            friendData.profilePicture,
                            45,
                            45,

                        );

                        return (
                            <TouchableOpacity style={styles.profileContainer}
                                onPress={() => handleFriendsData(friendData)}
                            >
                                <Image
                                    source={{ uri: newUserFullImage }}
                                    style={[styles.userImage, { backgroundColor: '#d6d4d4ff' }]}
                                    contentFit="cover"
                                    priority="high"
                                    cachePolicy="disk"
                                    onLoad={(e) => {
                                        // Log the event details to your //console
                                        //console.log(`Image loaded: ${friendData.profilePicture}`, e.source);
                                    }}
                                    onError={(e) => {
                                        // Critical: Check what errors are logged
                                        //console.log(`Image failed: ${friendData.profilePicture}`, e.error);
                                    }}
                                //blurhash="L02w~qRiEAEf_Nt7t7ayAYSf-oay"
                                />
                                {/* <FastImage
                                style={styles.userImage}
                                source={{
                                    uri: friendData.profilePicture,
                                    // Use immutable for maximum performance and efficiency
                                    cache: FastImage.cacheControl.immutable,
                                    priority: FastImage.priority.normal,
                                }}
                                resizeMode={FastImage.resizeMode.cover}
                            /> */}
                                <View>
                                    <Text style={{ fontSize: 16, color: Colours.DARKGRAY, fontFamily: 'Sen-Regular' }}>{friendData.username}</Text>
                                </View>
                            </TouchableOpacity>
                        )
                    }}
                />
            )}
            <Modal
                visible={showPublicProfile}
                transparent={true}
                animationType="fade"
                onRequestClose={() => setShowPublicProfile(false)}
            >
                <PublicProfile
                    setShowPublicProfile={setShowPublicProfile}
                    userData={userData}
                />
            </Modal>
        </View>
    )
}

const styles = StyleSheet.create({
    higherTablebodyContainer: {
        margin: 15,
        marginTop: 0,
        padding: 15,
        // width: 400,
        borderRadius: 15,
        //   height:200,
        backgroundColor: 'white',
        //   backgroundColor: '#E8E8E8',
        shadowColor: '#E8E8E8'
    },
    JoinedNumber: {
        display: 'flex',
        flexDirection: 'row',
        //    justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
    },
    inputTxt: {
        height: 40,
        width: 250,
        marginTop: 10,
        // gap: 10,
        padding: 10,
        borderWidth: 2.5,
        borderColor: Colours.LIGHTGRAY,
        borderRadius: 7,
        fontFamily: 'Sen-Regular',
        fontSize: 15,
        backgroundColor: Colours.LIGHTGRAY,
        marginBottom: 10,
        marginRight: 10,
    },

    searchBoxContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        // backgroundColor:'blue',

    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },
    userImage: {
        width: 45,
        height: 45,
        borderRadius: 99,

    },
    profileContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: 10,
        gap: 10,
    },
})

export default BodyFriendListSearch